﻿(function (angular, ToyotaForms) {
    'use strict';

    angular.module('Toyota.Directives')
        .directive('tyValidPostcode', ['$filter', 'API', '$q', function Map($filter, API, $q) {
            return {
                require: 'ngModel',
                link: function (scope, elm, attrs, ctrl) {
                    var postcode;

                    ctrl.$asyncValidators.postcode = function (modelValue, viewValue) {

                        if (ctrl.$isEmpty(modelValue)) {
                            // consider empty model valid
                            return $q.when();
                        }

                        var def = $q.defer();

                        postcode = $filter('formatArgs')(ToyotaForms.API.Validation.Postcode, [modelValue]);

                        if (/^\d{4}$/.test(viewValue)) {
                            ctrl.$setTouched();

                            API.get(postcode)
                                .then(function (req) {
                                    if (req.data.isValid) {
                                        def.resolve();
                                    }
                                    else {
                                        def.reject();
                                    }
                                }, function () {
                                    def.reject();
                                });
                        } else {
                            // Reject it because it doesn't even match the number-vetting regex.
                            def.reject();
                        }

                        return def.promise;
                    };
                }
            };
        }]);
})(window.angular, window.ToyotaForms);
